import { createFileRoute } from '@tanstack/react-router';

import { CustomizationsPage, customizationsQueryOptions } from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/customizations')({
  staticData: {
    crumb: 'dictionary:setup.tabs.customizations',
    tours: ['dictionary.customizations'],
  },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...customizationsQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: CustomizationsPage,
});
